import React from 'react';
import { Modal } from 'antd';
import QuickWorkbench from '../pages/QuickWorkbench';

interface QuickWorkbenchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const QuickWorkbenchModal: React.FC<QuickWorkbenchModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={672}
      centered
      destroyOnHidden
      styles={{ body: { padding: 0, borderRadius: 12, overflow: 'hidden' } }}
      style={{ maxWidth: '92vw' }}
      className="qw-icloud-modal"
    >
      <QuickWorkbench onRequestClose={onClose} />
    </Modal>
  );
};

export default QuickWorkbenchModal;


